import Municipalities from "./municipalities";

const municipalitiesPageRoutes = [{ path: "/autarquias", element: <Municipalities /> }];

export default municipalitiesPageRoutes;
